import { render, staticRenderFns } from "./mail_addr.vue?vue&type=template&id=6b9c1e8c&scoped=true&"
import script from "./mail_addr.vue?vue&type=script&lang=js&"
export * from "./mail_addr.vue?vue&type=script&lang=js&"
import style0 from "./mail_addr.vue?vue&type=style&index=0&id=6b9c1e8c&scoped=true&lang=less&"
import style1 from "./mail_addr.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c1e8c",
  null
  
)

export default component.exports